<div class="datasource-area" *ngIf="systemsDatasource">
  <as-split direction="horizontal" [unit]="'pixel'" (dragEnd)="onSplitDragEnd($event)" class="main-area"
    [gutterSize]="7">
    <as-split-area [order]="1">
      <app-configuration-datasource #datasourceInstance [dataSourceInstance]="systemsDatasource" [lazy]="true"
        [treeMaxHops]="10" [sortByName]="true" [sortPaddingZeros]="10" [highlightSelected]="true"
        [customerId]="this.selectedBmsCustomer.customerId" (onTreeNodeSelect)="onTreeNodeSelect($event)"
        [moveEnabled]="true" [expandRoot]="true" [eventLogdEnabled]="true">
      </app-configuration-datasource>
    </as-split-area>
    <as-split-area [(size)]="rightPanelWidth" [order]="2">
      <app-bms-data-collector-view #bmsDataCollectorView>
      </app-bms-data-collector-view>
    </as-split-area>
  </as-split>
</div>
